module.exports = __webpack_public_path__ + "img/work.jpg?6a353206e41552fa43622da35db39416";